module.exports = __webpack_public_path__ + "img/init_data.51685f69.svg";